import { useEffect, useRef } from 'react';
/**
 * Variation of the useEffect hook that only runs on updates, not on mount.
 */ export const useUpdateEffect = (effect, deps)=>{
    const isMounted = useRef(false);
    useEffect(()=>{
        if (!isMounted.current) {
            isMounted.current = true;
        } else {
            return effect();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
